import React from "react";

/**
 * Context to determine if the editor is allowed to manage user attributes while moderating comments, such as
 * trusting/untrusting a user.
 *
 * This context value is false by default.
 */
const ManageUserFeatureFlipContext = React.createContext(false);

export default ManageUserFeatureFlipContext;
